module.exports = __webpack_public_path__ + "img/logo.d7a2f64f.png";